import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=64a88d93&"
import script from "./ImageGallery.vue?vue&type=script&lang=ts&"
export * from "./ImageGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_71ad00c4/src/components/button/Circle.vue').default,AdaptiveImageNew: require('/tmp/build_71ad00c4/src/components/media/AdaptiveImageNew.vue').default,HighResolutionImage: require('/tmp/build_71ad00c4/src/components/media/HighResolutionImage.vue').default})
